import { pedagogicalApproachParameters } from '../../../../utils/defaultsProvider'
import USER_ROLES from "../../../../constants/userRoles.constants";

/* global Chart */
class StepConclusionsController {
    constructor(
        $mdDialog,
        evaluationService,
        pedagogicalService,
        userService,
        $q,
        $stateParams,
        $state,
        $timeout,
    ) {
        let self = this;
        let currentEvalId = $stateParams.id;
        let isMini = $state.includes('mini');
        self.othersConclusions = [];
        self.othersConclusionsShow = false;
        self.maxConclusionsNumber = 3;
        self.maxConclusionsCharLength = 200;
        self.othersScores = [];
        self.chartLabels = [];
        self.chartData = [];
        self.chartSeries = ['Your scores', 'Average Scores'];
        self.chartOptions = {
            spanGaps: false,
            responsive: true,
            events: [],
            scales: {
                yAxes: [{
                    ticks: {
                        beginAtZero: true,
                        min: 0,
                        max: 100,
                        callback: function(value) {
                            return value + "%";
                        }
                    }
                }],
                xAxes: [{
                    barThickness : 40,
                    ticks: {
                        fontSize: 12,
                        position: 'bottom'

                    },
                    gridLines: {
                        display:false
                    },
                    stacked: false
                }]
            },
            tooltips: {
                enabled: false
            },
            animation: {
                duration: 0,
                onComplete: function() {
                    var chartInstance = this.chart;
                    var ctx2 = chartInstance.ctx;
                    ctx2.textAlign = 'center';
                    ctx2.fillStyle = '#000';
                    this.data.datasets.forEach(function(dataset) {
                        if(!dataset._meta[Object.keys(dataset._meta)[0]].hidden) {
                            for (var i = 0; i < dataset.data.length; i++) {
                                var model = dataset._meta[Object.keys(dataset._meta)[0]].data[i]._model;
                                if(parseInt(dataset.data[i]) > 10) {
                                    ctx2.fillText(parseInt(dataset.data[i]) + "%", model.x, model.y);
                                } else {
                                    ctx2.fillText(parseInt(dataset.data[i]) + "%", model.x, model.y - 15);
                                }
                            }
                        }
                    });
                }
            },
            hover: {
                animationDuration: 0
            },
            legend: {
                display: true,
                position: 'bottom'
            }
        };
        self.myValues = [];
        self.averageValues = [];
        self.stateChangeCheck = true;
        self.isFinished = false;
        self.isAdmin = false;
        self.isManager = false;
        self.averageScore = 0;
        self.averageScoreMean = 0;

        let calculateMeanOfAspectsQuestions = (LEaspects) => {
            if (!LEaspects) {
                return 0;
            }

            let scoreAspects = 0;
            let counter = 0;

            LEaspects.forEach(leAspect => {
                leAspect.answers.forEach(answer => {
                    if (answer.score) {
                        scoreAspects += answer.score;
                        counter++;
                    }
                });
            });

            return (scoreAspects === 0) ? 0 : (scoreAspects / counter);
        };

        let calculateOverallScore = (paramMeansArray) => {
            const filter = paramMeansArray.filter(param => param !== 0);
            const sum = filter.length !== 0 ? filter.reduce((acc, param) => acc + param, 0) : 0;
            return sum === 0 ? 0 : (sum / filter.length);
        };

        let isANumberThatICareAbout = (value) => {
            return !isNaN(value) && value !== null
        };

        this.modifyLabelForOverWork = (value) => {
            let result = [];
            while (value.length > 0) {
                result.push(value.substring(0, 15).trim());
                value = value.substring(15).trim();
            }
            return result;
        };

        this.paramScore = (questions) => {
            let deviation = 0;
            let maxDeviation = 0;

            questions.forEach(question => {
                if (isANumberThatICareAbout(question.magnifyingGlass) || isANumberThatICareAbout(question.pin)) {
                    maxDeviation += 4;
                    if (isANumberThatICareAbout(question.magnifyingGlass) && isANumberThatICareAbout(question.pin)) {
                        deviation += Math.abs(question.magnifyingGlass - question.pin);
                    }
                }
            });

            return maxDeviation !== 0 ? (1 - deviation / maxDeviation) * 100 : 0;
        };

        this.loadEvaluation = () => {
            $timeout(() => {
                evaluationService.getEvaluationData(currentEvalId, isMini)
                    .then((data) => {
                        self.evaluation = data;
                        self.isFinished = evaluationService.isAfterFinish(data.status);
                        self.isManager = data.isManager;
                        self.isAdmin = userService.isInRole(USER_ROLES.ROLE_ADMIN);
                        self.scoreMean = calculateMeanOfAspectsQuestions(data.learningEngagement);
                        self.conclusions = data.conclusions;
                        self.exportedConclusions = data.conclusionsSummary ? data.conclusionsSummary : [];
                        self.exportedConclusionsPristine = JSON.parse(angular.toJson(self.exportedConclusions));
                        self.conclusionsPristine = JSON.parse(angular.toJson(data.conclusions));
                        let skillScoreArray = {};

                        self.ALevelSkills = self.evaluation.learningGoals.filter(skill => skill.importance === 'A');
                        self.allParams = self.evaluation.pedagogicalApproach;
                        self.myValues = [];
                        self.chartLabels = [];
                        self.allParams.forEach((param) => {
                            self.chartLabels.push(self.modifyLabelForOverWork(
                                pedagogicalApproachParameters.find(e => e.index === param.parameter).name));
                            self.myValues.push(self.paramScore(param.answers));
                        });
                        self.averageValues = [0, 0, 0, 0];
                        self.myValues.forEach((myValue, index) => {
                            self.averageValues[index] = myValue;
                            self.averageValues.push(myValue > 0 ? 1 : 0);
                        });

                        if (self.isFinished) {
                            evaluationService.getOthers('conclusions', self.evaluation.isMini, self.evaluation.id).then((data) => {
                                self.othersConclusions = data;
                            });

                            $q.all([
                                evaluationService.getOthers('pedagogical_approaches', self.evaluation.isMini, self.evaluation.id),
                                evaluationService.getOthers('learning_engagements', self.evaluation.isMini, self.evaluation.id)
                            ]).then(res => {
                                self.othersScores = res[0];

                                self.othersScores.forEach((other, index) => {
                                    const otherApproaches = res[1][index];
                                    const otherSavedData = other.pedagogicalApproaches;
                                    other.summary = {
                                        strengths: otherSavedData.strengths,
                                        developmentAreas: otherSavedData.developmentAreas
                                    };
                                    if (otherApproaches && otherApproaches.learningEngagements) {
                                        other.scoreMean = calculateMeanOfAspectsQuestions(otherApproaches.learningEngagements);
                                    } else {
                                        other.scoreMean = 0;
                                    }
                                    other.scores = [];

                                    otherSavedData.forEach((param) => {
                                        const index = self.allParams.findIndex(allParam => allParam.parameter === param.parameter);
                                        const score = self.paramScore(param.answers);
                                        if (self.averageValues[index] > -1) {
                                            self.averageValues[index] += score;
                                            if (score > 0) {
                                                self.averageValues[index + 4] += 1;
                                            }
                                        }
                                        other.scores.push(score);
                                    });
                                });

                                if (self.othersScores.length) {
                                    self.overallScore = calculateOverallScore(self.myValues);
                                    const numberOfAvailableOverallScores = self.othersScores.reduce((prev, other) => {
                                        return prev + (calculateOverallScore(other.scores) > 0 ? 1 : 0);
                                    }, 0);

                                    if (numberOfAvailableOverallScores > 0) {
                                        self.averageScore = self.othersScores.reduce((prev, other) => {
                                            return prev + calculateOverallScore(other.scores);
                                        }, self.overallScore) / (numberOfAvailableOverallScores + (self.overallScore > 0 ? 1 : 0));
                                    } else {
                                        self.averageScore = 0;
                                    }

                                    self.averageScoreMean = self.evaluation.learningEngagementsSummary.reduce((prev, other) => {
                                        return prev + other.score;
                                    }, 0) / self.evaluation.learningEngagementsSummary.length;
                                }
                                self.prepareChartData();
                            });
                        }

                        if (!self.isFinished) {
                            self.prepareChartData();
                        }
                    });
            }, 1000);
        };

        this.prepareChartData = () => {
            self.overallScore = calculateOverallScore(self.myValues);
            const chartData = {
                labels: [],
                myValues: [],
                averageValues: []
            };
            self.myValues.forEach((value, index) => {
                if(self.isFinished) {
                    if(self.othersScores.length > 0 && self.averageValues[index + 4] > 0) {
                        chartData.myValues.push(self.myValues[index]);
                        chartData.averageValues.push(self.averageValues[index] / (self.averageValues[index + 4]));
                        chartData.labels.push(self.chartLabels[index]);
                    } else if(self.myValues[index] > 0) {
                        chartData.labels.push(self.chartLabels[index]);
                        chartData.myValues.push(self.myValues[index]);
                        chartData.averageValues.push(self.myValues[index]);

                        self.averageScoreMean = self.scoreMean;
                        self.averageScore = self.overallScore;
                    }
                } else {
                    chartData.labels.push(self.chartLabels[index]);
                    chartData.myValues.push(self.myValues[index]);
                }
            });
            self.chartLabels = chartData.labels;
            self.overallScore = calculateOverallScore(self.myValues);
            self.chartData = self.isFinished ?
                [chartData.myValues, chartData.averageValues] : [chartData.myValues];
        };

        this.showNewConclusionsDialog = (list) => {
            $mdDialog.show({
                clickOutsideToClose: true,
                templateUrl: 'newConclusionDialog.tmpl.html',
                parent: angular.element(document.body),
                multiple: true,
                controller: function DialogController($scope, $mdDialog) {
                    $scope.maxConclusionsCharLength = self.maxConclusionsCharLength;
                    $scope.closeDialog = function() {
                        $mdDialog.cancel();
                    };
                    $scope.save = function(result) {
                        if (result && result.text.length <= self.maxConclusionsCharLength) {
                            $mdDialog.hide(result);
                        }
                    };
                }
            })
            .then(function(result) {
                list.push({text: result.text});
            }, function() {});
        };

        this.removeCurrentConclusion = (conclusions, index) => {
            $mdDialog.show(
                $mdDialog.confirm({
                    title: 'Warning',
                    textContent: `Are you sure you want to delete this conclusion? `,
                    ok: 'OK',
                    cancel: 'Cancel',
                    multiple: true
                })
            ).then(function() {
                conclusions.splice(index, 1);
            }, function() { return false; });
        };

        this.saveExportedData = () => {
            let dataToSend = {"conclusions": self.exportedConclusions};
            self.stateChangeCheck = false;
            evaluationService.saveExportedConclusions(currentEvalId, dataToSend);
        };

        this.handleNextButton = (redirect) => {
            let dataToSend = {"conclusions": self.conclusions};
            self.stateChangeCheck = false;
            evaluationService.saveConclusions(currentEvalId, dataToSend, isMini, redirect);
        };

        this.handleFinishAndSendApproval = () => {
            $mdDialog.show({
                clickOutsideToClose: true,
                templateUrl: 'finishEvaluationDialog.tmpl.html',
                parent: angular.element(document.body),
                multiple: false,
                controller: function DialogController($scope, $mdDialog) {
                    $scope.cancelDialog = function() {
                        $mdDialog.cancel();
                    };
                    $scope.finishEv = function() {
                        $mdDialog.hide();
                    };
                }
            })
            .then(function() {
                let dataToSend = {"conclusions": self.conclusions};
                self.stateChangeCheck = false;
                evaluationService.saveConclusions(currentEvalId, dataToSend, isMini, false).then(() => {
                    evaluationService.finishEvaluation(currentEvalId).then((response) => {
                        self.loadEvaluation();
                    });
                });
            }, function() {});
        };

        this.handleUnlockFinishedEvaluation = () => {
            evaluationService.unlockEvaluation(currentEvalId).then((response) => {
                self.loadEvaluation();
            });
        };

        this.loadEvaluation();
    }

    closeEditMode(isValid) {
        return !isValid;
    }

    $onDestroy() {
        if ((!angular.equals(this.conclusionsPristine, this.conclusions)) && this.stateChangeCheck) {
            this.$timeout(() => {
                this.handleNextButton(false);
            }, 0);
        }
    }
}

export default StepConclusionsController;



// WEBPACK FOOTER //
// ./src/app/pages/evaluation/pages/stepConclusions/stepConclusionsController.js